<mat-toolbar color="primary" fide>
    <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
      <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
    </button>
    <!-- <app-navebar></app-navebar> -->
  
  </mat-toolbar>